/**
 * @internal
 */
import React, { createContext, useContext } from 'react';
export const InternalContext = createContext({
    isInternal: false,
});
const InternalProvider = ({ children }) => {
    return (React.createElement(InternalContext.Provider, { value: { isInternal: true } }, children));
};
export default InternalProvider;
export const useInternalApp = () => useContext(InternalContext).isInternal;
